import { useState, useEffect, useRef } from "react";

/* ─────────────────────────────────────────────────────────────
   DATA  (unchanged)
───────────────────────────────────────────────────────────── */
const committeeData = [
  {
    id: "chairman",
    label: "Chairman — SMPACE 2026",
    icon: "🎓",
    members: [
      { name: "Dr. Bhavana B.", role: "Associate Professor & Director", org: "REVA University" },
    ],
    highlight: true,
  },
  {
    id: "technical",
    label: "Technical Committee",
    icon: "⚙️",
    members: [
      { name: "Dr. Seelam Srikanth Reddy", org: "SOCE, REVA University, India" },
      { name: "Dr. Sanjay Raj A.", org: "SOCE, REVA University, India" },
      { name: "Dr. Nagesh M. A.", org: "SOCE, REVA University, India" },
      { name: "Dr. Kanimozhee S.", org: "SOCE, REVA University, India" },
      { name: "Mrs. Pavithra M. P.", org: "SOCE, REVA University, India" },
      { name: "Dr. Nanjundarao K. S.", org: "SOCE, REVA University, India" },
    ],
  },
  {
    id: "website",
    label: "Website & Branding",
    icon: "🌐",
    members: [
      { name: "Mr. Jayachandra", org: "SOCE, REVA University, India" },
      { name: "Mr. Harish Sagar M.", org: "SOCE, REVA University, India" },
    ],
  },
  {
    id: "hospitality",
    label: "Hospitality Committee",
    icon: "🤝",
    members: [
      { name: "Dr. Kannam Praveen", org: "SOCE, REVA University, India" },
      { name: "Dr. Pradeep Kumar B. K.", org: "SOCE, REVA University, India" },
      { name: "Dr. Ajaybhaskar V Reddy", org: "SOCE, REVA University, India" },
      { name: "Mr. Nanjunda K. N.", org: "SOCE, REVA University, India" },
      { name: "Mr. Raghunandan K.", org: "SOCE, REVA University, India" },
      { name: "Mr. Avinash Deshpande", org: "SOCE, REVA University, India" },
    ],
  },
  {
    id: "transport",
    label: "Transportation & Accommodation",
    icon: "🚌",
    members: [
      { name: "Dr. Amaranatha G. A.", org: "SOCE, REVA University, India" },
      { name: "Dr. Madhu K. A.", org: "SOCE, REVA University, India" },
      { name: "Mr. Venkatesh Wadki", org: "SOCE, REVA University, India" },
      { name: "Mr. K. Chandraprakssh", org: "SOCE, REVA University, India" },
      { name: "Mr. Raveesh J.", org: "SOCE, REVA University, India" },
    ],
  },
  {
    id: "registration",
    label: "Registration Committee",
    icon: "📋",
    members: [
      { name: "Mrs. Minakshi Mishra", org: "SOCE, REVA University, India" },
      { name: "Dr. Pushpa Lumina", org: "SOCE, REVA University, India" },
      { name: "Dr. Preethi S.", org: "SOCE, REVA University, India" },
      { name: "Dr. Lovely Sabat", org: "SOCE, REVA University, India" },
      { name: "Mr. Sreenatha M.", org: "SOCE, REVA University, India" },
      { name: "Mr. Srinidhi S. U.", org: "SOCE, REVA University, India" },
      { name: "Dr. Nandini D. N.", org: "SOCE, REVA University, India" },
    ],
  },
  {
    id: "report",
    label: "Report & Documentation",
    icon: "📄",
    members: [
      { name: "Dr. Y. Bharath Simha Reddy", org: "SOCE, REVA University, India" },
      { name: "Dr. Mehar Babu Ravula", org: "SOCE, REVA University, India" },
      { name: "Dr. Vigneswaran S.", org: "SOCE, REVA University, India" },
    ],
  },
  {
    id: "finance",
    label: "Finance & Accounts",
    icon: "💼",
    members: [
      { name: "Mr. Prashanth N.", org: "SOCE, REVA University, India" },
      { name: "Mrs. Shylaja N.", org: "SOCE, REVA University, India" },
      { name: "Mr. Rakesh H.", org: "SOCE, REVA University, India" },
    ],
  },
];

/* ─────────────────────────────────────────────────────────────
   HELPERS
───────────────────────────────────────────────────────── */
function getInitials(name) {
  return name
    .replace(/^(Dr\.|Mrs\.|Mr\.|Prof\.)\s*/i, "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0].toUpperCase())
    .join("");
}

const avatarPalettes = [
  { bg: "bg-orange-100", text: "text-orange-700", border: "border-orange-300", ring: "ring-orange-200" },
  { bg: "bg-sky-100",    text: "text-sky-700",    border: "border-sky-300",    ring: "ring-sky-200"    },
  { bg: "bg-emerald-100",text: "text-emerald-700",border: "border-emerald-300",ring: "ring-emerald-200"},
  { bg: "bg-violet-100", text: "text-violet-700", border: "border-violet-300", ring: "ring-violet-200" },
  { bg: "bg-rose-100",   text: "text-rose-700",   border: "border-rose-300",   ring: "ring-rose-200"   },
];

function Avatar({ name, size = "md" }) {
  const initials = getInitials(name);
  const pal = avatarPalettes[name.charCodeAt(0) % avatarPalettes.length];
  const sz =
    size === "xl" ? "w-24 h-24 text-3xl ring-4" :
    size === "sm" ? "w-9 h-9 text-xs ring-2"  :
                    "w-11 h-11 text-sm ring-2";
  return (
    <div className={`${sz} rounded-full ${pal.bg} ${pal.text} border-2 ${pal.border} ${pal.ring} ring-offset-1 flex items-center justify-center font-black flex-shrink-0 tracking-wider select-none`}>
      {initials}
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   TOPBAR  (unchanged structure, enhanced styling)
───────────────────────────────────────────────────────── */
function TopBar() {
  return (
    <div className="bg-[#0f0f1a] text-white text-xs flex flex-wrap items-center justify-between gap-2 px-6 py-2.5 border-b border-white/5">
      <div className="flex items-center gap-2">
        <span className="inline-flex items-center justify-center w-5 h-5 rounded bg-orange-500/20 text-orange-400 text-[10px]">📅</span>
        <span className="font-bold text-orange-300 tracking-wide">July 31 &amp; August 01, 2026</span>
        <span className="text-white/20 mx-1">|</span>
        <span className="text-white/50">REVA University, Bengaluru, India</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-white/40">Abstract Submission Deadline:</span>
        <span className="font-bold text-white bg-orange-500/20 px-2 py-0.5 rounded border border-orange-500/30">June 15, 2026</span>
        <span className="text-white/20 mx-1">|</span>
        <span className="text-orange-400">✉</span>
        <a href="mailto:ruceconference@reva.edu.in" className="text-orange-300 hover:text-orange-100 transition-colors underline underline-offset-2 decoration-orange-500/40">
          ruceconference@reva.edu.in
        </a>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   NAVBAR  (commented out — preserved exactly)
───────────────────────────────────────────────────────── */
// const navLinks = ["Home", "About", "Research Areas", "Paper Submission", "Committee", "Speakers", "Contact"];

// function Navbar() {
//   const [active, setActive] = useState("Committee");

//   return (
//     <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
//       <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
//         {/* Logo */}
//         <div className="flex items-center gap-3">
//           <div className="w-10 h-10 bg-[#1a1a2e] rounded flex items-center justify-center">
//             <span className="text-orange-400 font-black text-lg leading-none">R</span>
//           </div>
//           <div>
//             <div className="font-black text-[#1a1a2e] text-sm leading-tight tracking-wide">REVA</div>
//             <div className="font-black text-[#1a1a2e] text-sm leading-tight tracking-wide">UNIVERSITY</div>
//             <div className="text-gray-400 text-[9px] tracking-widest leading-none">Bengaluru, India</div>
//           </div>
//           <div className="ml-3 border-l border-gray-200 pl-3">
//             <div className="bg-orange-500 text-white text-[10px] font-bold px-2 py-0.5 rounded mb-0.5 tracking-wider">
//               SMPACE-2026
//             </div>
//             <div className="text-gray-500 text-[10px] leading-tight max-w-[200px]">
//               10th International Conference on Sustainable Civil Engineering
//             </div>
//           </div>
//         </div>

//         {/* Nav Links */}
//         <div className="hidden lg:flex items-center gap-1">
//           {navLinks.map((link) => (
//             <button
//               key={link}
//               onClick={() => setActive(link)}
//               className={`px-3 py-1.5 text-sm font-medium rounded transition-all duration-150 ${
//                 active === link
//                   ? "text-orange-500 border-b-2 border-orange-500 rounded-none"
//                   : "text-gray-600 hover:text-orange-500"
//               }`}
//             >
//               {link}
//             </button>
//           ))}
//         </div>

//         {/* CTA */}
//         <button className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-sm px-5 py-2 rounded transition-colors flex items-center gap-1.5">
//           Register Now <span className="text-base">›</span>
//         </button>
//       </div>
//     </nav>
//   );
// }

/* ─────────────────────────────────────────────────────────────
   PAGE HERO  (enhanced — same structure, richer visuals)
───────────────────────────────────────────────────────── */
function PageHero() {
  return (
    <div className="bg-[#0d0d1f] relative overflow-hidden">
      {/* Dot-matrix background */}
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage: "radial-gradient(circle, #f97316 1px, transparent 1px)",
          backgroundSize: "28px 28px",
        }}
      />
      {/* Grid lines */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(249,115,22,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(249,115,22,0.6) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />
      {/* Central glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full bg-orange-500/10 blur-[80px] pointer-events-none" />
      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#0d0d1f] to-transparent pointer-events-none" />
      {/* Decorative arc */}
      <div className="absolute -bottom-1 left-0 right-0 h-6 overflow-hidden">
        <div className="w-full h-20 rounded-t-[50%] bg-gray-50" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-20 text-center">
        {/* Pill badge */}
        <div className="inline-flex items-center gap-2 bg-orange-500/15 border border-orange-500/30 rounded-full px-5 py-1.5 mb-6 backdrop-blur-sm">
          <span className="w-2 h-2 rounded-full bg-orange-400 animate-pulse shadow-[0_0_8px_#f97316]" />
          <span className="text-orange-300 text-[11px] font-bold tracking-[0.18em] uppercase">
            International Conference · SMPACE 2026
          </span>
        </div>

        {/* Title */}
        <h1 className="text-5xl md:text-6xl font-black text-white mb-4 leading-[1.05] tracking-tight">
          Organizing{" "}
          <span
            className="text-transparent bg-clip-text"
            style={{ backgroundImage: "linear-gradient(135deg, #f97316 0%, #fb923c 50%, #fdba74 100%)" }}
          >
            Committee
          </span>
        </h1>

        <p className="text-white/40 text-sm tracking-[0.22em] uppercase mb-8 font-medium">
          SOCE · REVA University, Bengaluru, India · July 31 – August 01, 2026
        </p>

        {/* Accent line */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-10 h-px bg-orange-500/40" />
          <div className="w-16 h-1 bg-gradient-to-r from-orange-600 to-orange-400 rounded-full shadow-[0_0_12px_#f97316]" />
          <div className="w-10 h-px bg-orange-500/40" />
        </div>

        {/* Breadcrumb */}
        <div className="flex items-center justify-center gap-2 text-xs text-white/30 font-medium">
          <span className="hover:text-orange-400 cursor-pointer transition-colors duration-200">Home</span>
          <span className="text-white/20">›</span>
          <span className="text-orange-400">Committee</span>
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   STATS ROW  (enhanced — animated count-up feel, richer cards)
───────────────────────────────────────────────────────── */
function StatsRow() {
  const total = committeeData.reduce((a, c) => a + c.members.length, 0) - 1;
  const stats = [
    { label: "Total Members", value: total, icon: "👥", color: "text-orange-500", bg: "bg-orange-50", border: "border-orange-100" },
    { label: "Sub-Committees", value: committeeData.length - 1, icon: "🏛️", color: "text-sky-500", bg: "bg-sky-50", border: "border-sky-100" },
    { label: "Institution", value: "REVA", icon: "🎓", color: "text-emerald-500", bg: "bg-emerald-50", border: "border-emerald-100" },
    { label: "Conference Edition", value: "10th", icon: "🏆", color: "text-violet-500", bg: "bg-violet-50", border: "border-violet-100" },
  ];

  return (
    <div className="bg-gray-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-7">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`group flex items-center gap-4 ${s.bg} border ${s.border} rounded-2xl p-4 hover:shadow-md transition-all duration-300 hover:-translate-y-0.5`}
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className={`w-11 h-11 rounded-xl ${s.bg} border ${s.border} shadow-sm flex items-center justify-center text-xl flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                {s.icon}
              </div>
              <div>
                <div className={`text-2xl font-black ${s.color} leading-none tabular-nums`}>{s.value}</div>
                <div className="text-[10px] text-gray-400 uppercase tracking-wider font-semibold mt-1 leading-tight">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   CHAIRMAN CARD  (enhanced — more refined, premium feel)
───────────────────────────────────────────────────────── */
function ChairmanCard({ member }) {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      className={`relative bg-[#0d0d1f] rounded-3xl overflow-hidden border transition-all duration-500 shadow-2xl mb-10 ${hov ? "border-orange-400/50 shadow-orange-900/30" : "border-orange-500/15"}`}
    >
      {/* Multi-layer decorative BG */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -right-16 -top-16 w-80 h-80 rounded-full bg-orange-500/8 blur-2xl" />
        <div className="absolute right-24 -bottom-20 w-56 h-56 rounded-full bg-orange-600/5 blur-xl" />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: "radial-gradient(circle, #f97316 1px, transparent 1px)",
            backgroundSize: "20px 20px",
          }}
        />
        {/* left accent bar — gradient */}
        <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-orange-400 via-orange-500 to-transparent" />
      </div>

      <div className="relative flex flex-col md:flex-row items-center md:items-center gap-8 p-8 md:p-10">
        {/* Avatar with glow ring */}
        <div className={`relative flex-shrink-0 transition-transform duration-300 ${hov ? "scale-105" : ""}`}>
          <div className="w-[88px] h-[88px] rounded-full bg-gradient-to-br from-orange-400 to-orange-700 flex items-center justify-center text-white text-3xl font-black shadow-xl shadow-orange-900/50 ring-4 ring-orange-500/20">
            {getInitials(member.name)}
          </div>
          <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-[#0d0d1f] rounded-full border-2 border-orange-500/30 flex items-center justify-center text-base">
            🎓
          </div>
          {hov && (
            <div className="absolute inset-0 rounded-full animate-ping bg-orange-500/10 pointer-events-none" />
          )}
        </div>

        {/* Info */}
        <div className="text-center md:text-left flex-1">
          <div className="inline-flex items-center gap-2 mb-3">
            <div className="h-px w-8 bg-orange-500/50" />
            <span className="text-orange-400 text-[10px] font-black uppercase tracking-[0.22em]">
              Conference Chairman — SMPACE 2026
            </span>
            <div className="h-px w-8 bg-orange-500/50" />
          </div>
          <h2 className="text-white text-3xl md:text-4xl font-black mb-1.5 leading-tight tracking-tight">{member.name}</h2>
          <p className="text-orange-200/70 text-sm font-semibold">{member.role}</p>
          <p className="text-white/25 text-xs mt-1 font-medium tracking-wide">{member.org}</p>
          {/* Tags */}
          <div className="flex flex-wrap justify-center md:justify-start gap-2 mt-4">
            {["SOCE", "REVA University", "Bangalore"].map((t) => (
              <span key={t} className="text-[10px] font-bold text-orange-300/60 bg-orange-500/10 border border-orange-500/20 rounded-full px-3 py-1 tracking-wide uppercase">
                {t}
              </span>
            ))}
          </div>
        </div>

        {/* Publication badge */}
        <div className="flex-shrink-0">
          <div className="bg-gradient-to-br from-white/5 to-white/[0.02] border border-orange-500/20 rounded-2xl px-6 py-5 text-center backdrop-blur-sm hover:border-orange-400/40 transition-colors duration-300">
            <div className="text-orange-400/70 text-[10px] uppercase tracking-[0.18em] font-bold mb-2">Publication Partner</div>
            <div className="text-white font-black text-xl">📘 Springer</div>
            <div className="text-white/20 text-[10px] mt-1 tracking-widest uppercase">Peer Reviewed</div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   MEMBER ROW  (enhanced — richer hover, role badge)
───────────────────────────────────────────────────────── */
function MemberRow({ member, index = 0 }) {
  const [hov, setHov] = useState(false);
  const prefix = member.name.match(/^(Dr\.|Mrs\.|Mr\.|Prof\.)/i)?.[1] || "";
  const prefixColor = {
    "Dr.": "bg-blue-100 text-blue-600",
    "Mrs.": "bg-rose-100 text-rose-600",
    "Mr.": "bg-gray-100 text-gray-500",
    "Prof.": "bg-violet-100 text-violet-600",
  }[prefix] || "bg-gray-100 text-gray-400";

  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      className={`group flex items-center gap-3 px-3 py-2.5 rounded-xl cursor-default transition-all duration-200 ${
        hov ? "bg-orange-50 translate-x-1.5 shadow-sm" : "bg-white/60"
      } border ${hov ? "border-orange-200" : "border-gray-100/80"}`}
      style={{ animationDelay: `${index * 30}ms` }}
    >
      <Avatar name={member.name} size="sm" />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5 min-w-0">
          {prefix && (
            <span className={`text-[9px] font-black px-1.5 py-0.5 rounded uppercase tracking-wide flex-shrink-0 ${prefixColor}`}>
              {prefix.replace(".", "")}
            </span>
          )}
          <span className="font-bold text-[13px] text-gray-800 truncate">
            {member.name.replace(/^(Dr\.|Mrs\.|Mr\.|Prof\.)\s*/i, "")}
          </span>
        </div>
        <div className="text-[11px] text-gray-400 truncate mt-0.5">{member.role || member.org}</div>
      </div>
      <span className={`text-orange-300 text-sm transition-all duration-200 flex-shrink-0 ${hov ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-1"}`}>›</span>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   COMMITTEE CARD  (enhanced — glassmorphism header, progress bar)
───────────────────────────────────────────────────────── */
const iconConfig = {
  "⚙️": { bg: "bg-blue-50",   border: "border-blue-100",   text: "text-blue-600",   accent: "from-blue-400",   bar: "bg-blue-400"   },
  "🌐": { bg: "bg-cyan-50",   border: "border-cyan-100",   text: "text-cyan-600",   accent: "from-cyan-400",   bar: "bg-cyan-400"   },
  "🤝": { bg: "bg-green-50",  border: "border-green-100",  text: "text-green-600",  accent: "from-green-400",  bar: "bg-green-400"  },
  "🚌": { bg: "bg-amber-50",  border: "border-amber-100",  text: "text-amber-600",  accent: "from-amber-400",  bar: "bg-amber-400"  },
  "📋": { bg: "bg-violet-50", border: "border-violet-100", text: "text-violet-600", accent: "from-violet-400", bar: "bg-violet-400" },
  "📄": { bg: "bg-rose-50",   border: "border-rose-100",   text: "text-rose-600",   accent: "from-rose-400",   bar: "bg-rose-400"   },
  "💼": { bg: "bg-orange-50", border: "border-orange-100", text: "text-orange-600", accent: "from-orange-400", bar: "bg-orange-400" },
};

const maxMembers = Math.max(...committeeData.filter(c => !c.highlight).map(c => c.members.length));

function CommitteeCard({ committee, index }) {
  const [open, setOpen] = useState(true);
  const cfg = iconConfig[committee.icon] || { bg: "bg-gray-50", border: "border-gray-100", text: "text-gray-600", accent: "from-gray-400", bar: "bg-gray-400" };
  const pct = Math.round((committee.members.length / maxMembers) * 100);

  return (
    <div
      className="bg-white rounded-2xl border border-gray-100/80 shadow-sm hover:shadow-lg hover:border-gray-200 transition-all duration-300 overflow-hidden flex flex-col group"
      style={{ animation: `fadeUpCard 0.5s ease ${index * 70}ms both` }}
    >
      {/* Coloured top bar */}
      <div className={`h-0.5 w-full bg-gradient-to-r ${cfg.accent} to-transparent`} />

      {/* Header */}
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-3 px-5 py-4 w-full text-left"
      >
        <div className={`w-10 h-10 rounded-xl border ${cfg.bg} ${cfg.border} ${cfg.text} flex items-center justify-center text-lg flex-shrink-0 group-hover:scale-110 transition-transform duration-300 shadow-sm`}>
          {committee.icon}
        </div>
        <div className="flex-1 min-w-0">
          <div className={`font-black text-[12.5px] text-[#0d0d1f] uppercase tracking-wider leading-tight group-hover:${cfg.text} transition-colors duration-200`}>
            {committee.label}
          </div>
          <div className="flex items-center gap-2 mt-1">
            <div className="flex-1 h-1 bg-gray-100 rounded-full overflow-hidden">
              <div
                className={`h-full ${cfg.bar} rounded-full transition-all duration-700`}
                style={{ width: open ? `${pct}%` : "0%" }}
              />
            </div>
            <span className="text-[10px] text-gray-400 font-semibold flex-shrink-0">
              {committee.members.length} member{committee.members.length !== 1 ? "s" : ""}
            </span>
          </div>
        </div>
        <div className={`w-6 h-6 rounded-full ${cfg.bg} ${cfg.border} border flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${open ? "rotate-90" : ""}`}>
          <span className={`${cfg.text} text-sm font-black leading-none`}>›</span>
        </div>
      </button>

      {/* Divider */}
      <div className={`mx-5 h-px bg-gradient-to-r ${cfg.accent} to-transparent opacity-30`} />

      {/* Members — animated expand */}
      <div className={`overflow-hidden transition-all duration-400 ${open ? "max-h-[800px] opacity-100" : "max-h-0 opacity-0"}`}>
        <div className="p-3 flex flex-col gap-1">
          {committee.members.map((m, i) => (
            <MemberRow key={m.name} member={m} index={i} />
          ))}
        </div>
      </div>

      {/* Collapsed peek */}
      {!open && (
        <div className="px-5 py-3 flex items-center gap-2">
          <div className="flex -space-x-1.5">
            {committee.members.slice(0, 5).map((m) => (
              <Avatar key={m.name} name={m.name} size="sm" />
            ))}
          </div>
          <span className="text-[11px] text-gray-400 font-medium ml-1">Click to expand</span>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   SECTION DIVIDER  (enhanced)
───────────────────────────────────────────────────────── */
function SectionDivider({ label }) {
  return (
    <div className="flex items-center gap-4 my-8">
      <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-200 to-gray-200" />
      <div className="flex items-center gap-2.5 bg-[#0d0d1f] text-orange-300 text-[11px] font-black uppercase tracking-[0.2em] px-5 py-2 rounded-full shadow-lg shadow-black/10 border border-orange-500/20">
        <span className="w-1.5 h-1.5 rounded-full bg-orange-400 shadow-[0_0_6px_#f97316]" />
        {label}
        <span className="w-1.5 h-1.5 rounded-full bg-orange-400 shadow-[0_0_6px_#f97316]" />
      </div>
      <div className="flex-1 h-px bg-gradient-to-l from-transparent via-gray-200 to-gray-200" />
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   FOOTER  (enhanced — richer layout)
───────────────────────────────────────────────────────── */
function Footer() {
  return (
    <div className="bg-[#0d0d1f] mt-16 border-t border-orange-500/10">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Left */}
          <div className="text-center md:text-left">
            <div className="flex items-center gap-2 justify-center md:justify-start mb-2">
              <div className="w-5 h-5 rounded bg-orange-500 flex items-center justify-center">
                <span className="text-white font-black text-xs leading-none">R</span>
              </div>
              <span className="text-orange-400 text-xs font-black uppercase tracking-[0.2em]">REVA University</span>
            </div>
            <p className="text-white/25 text-xs leading-relaxed">
              10th International Conference on Sustainable Civil Engineering<br />
              SOCE · Bengaluru, India · July 31 – August 01, 2026
            </p>
          </div>

          {/* Center */}
          <div className="text-center">
            <div className="text-white/10 text-[10px] uppercase tracking-widest mb-1">Publication Partner</div>
            <div className="text-white font-black text-lg">📘 Springer</div>
            <div className="flex gap-1 mt-2 justify-center">
              {["#1a1a2e","#1a1a2e","#1a1a2e"].map((_,i) => (
                <div key={i} className="w-1.5 h-1.5 rounded-full bg-orange-500/30" />
              ))}
            </div>
          </div>

          {/* Right */}
          <div className="text-center md:text-right">
            <div className="text-white/20 text-[10px] uppercase tracking-wider mb-1">Contact</div>
            <a href="mailto:ruceconference@reva.edu.in" className="text-orange-400 text-xs hover:text-orange-200 transition-colors">
              ruceconference@reva.edu.in
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/15 text-xs">© 2026 REVA University. All rights reserved.</p>
          <p className="text-white/15 text-xs">SMPACE — 2026 Organizing Committee</p>
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   ROOT PAGE  (preserved structure — TopBar/Navbar/CTA commented as given)
───────────────────────────────────────────────────────── */
export default function CommitteePage() {
  const chairman = committeeData.find((c) => c.highlight);
  const rest = committeeData.filter((c) => !c.highlight);

  return (
    <div className="min-h-screen bg-gray-50 font-sans antialiased">
      {/* Google Fonts */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Outfit:wght@400;500;600;700;800;900&display=swap');

        * { box-sizing: border-box; }
        body, html { font-family: 'Outfit', sans-serif; }
        h1, h2 { font-family: 'Instrument Serif', Georgia, serif; }

        @keyframes fadeUpCard {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* Smooth collapse */
        .max-h-0   { max-height: 0 !important; }
        .max-h-800 { max-height: 800px !important; }
      `}</style>

      {/* ── TOPBAR ── */}
      <TopBar />

      {/* <Navbar /> */}

      {/* ── HERO ── */}
      <PageHero />

      {/* ── STATS ── */}
      <StatsRow />

      {/* ── MAIN CONTENT ── */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10">

        {/* Chairman */}
        <SectionDivider label="Conference Chair" />
        <ChairmanCard member={chairman.members[0]} />

        {/* Sub-Committees */}
        <SectionDivider label="Sub-Committees" />

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
          {rest.map((c, i) => (
            <CommitteeCard key={c.id} committee={c} index={i} />
          ))}
        </div>

        {/* CTA — commented out as per your version */}
        {/* <div className="mt-14 rounded-2xl bg-[#1a1a2e] border border-orange-500/20 overflow-hidden relative">
          <div className="absolute inset-0 pointer-events-none overflow-hidden">
            <div className="absolute right-0 top-0 w-64 h-64 rounded-full bg-orange-500/10 blur-3xl" />
          </div>
          <div className="relative p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <div className="text-orange-400 text-xs font-bold uppercase tracking-widest mb-2">Join Us</div>
              <h3 className="text-white text-2xl font-black mb-1">Submit Your Research Paper</h3>
              <p className="text-gray-400 text-sm">Abstract submission deadline: <span className="text-orange-300 font-semibold">June 15, 2026</span></p>
            </div>
            <div className="flex gap-3 flex-shrink-0">
              <button className="border border-orange-500/50 text-orange-300 hover:bg-orange-500/10 px-5 py-2.5 rounded-lg text-sm font-bold transition-all duration-200">
                Learn More
              </button>
              <button className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-6 py-2.5 rounded-lg text-sm transition-all duration-200 shadow-lg shadow-orange-900/30">
                Register Now →
              </button>
            </div>
          </div>
        </div> */}

      </div>

      {/* ── FOOTER ── */}
      <Footer />
    </div>
  );
}